import { storeToRefs } from 'pinia';
import { filterModalUiStore } from '~/stores/filterModalUi';

export default function () {

  const store = filterModalUiStore();
  const { isFilterModalOpen } = storeToRefs(store);

  return {
    ...store,
    isFilterModalOpen,
  };

}